import React, { useContext, useState } from 'react'
import { DashboardContext } from './card'
import JourneyPieChart from './piechart'
import { Button, Tooltip, Box } from '@mui/material'
import NumbersIcon from '@mui/icons-material/Numbers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';
import JourneyBarChart from './barchart';
import JourneyPoligonChart from './poligongraph';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const defaultOptions = {
    'count': { name: 'Quantidade', icon: (<NumbersIcon />) } ,
    'value': { name: 'Valor', icon: (<AttachMoneyIcon />) },
    'duration': { name: 'Tempo', icon: (<AccessTimeIcon />) },
    'conversion': { name: 'Conversão', icon: (<PercentIcon />) }
}

const DashView = ({name,  rows, vx, vy, renderValue = null }) => {

    const { type } = useContext(DashboardContext)

    const [selectedVy, setSelectedVy] = useState(localStorage.getItem(`${name}-selector`) || vy[0] || 'count')

    return (
        <>
            <Box sx={{display:'flex', justifyContent: 'flex-end', gap: '.25rem'}}>
                {vy.map(item =>
                    <Tooltip title={defaultOptions[item]?.name}>
                        <span>
                            <Button 
                                sx={{minWidth: '2.5rem', width: '2.5rem'}}
                                onClick={() => {
                                    setSelectedVy(item);
                                    localStorage.setItem(`${name}-selector`, item)
                                }}
                                variant={selectedVy === item ? 'contained' : ''}>
                                {defaultOptions[item]?.icon}
                            </Button>
                        </span>
                    </Tooltip>
                )}
            </Box>
            {type === 'pie' && <JourneyPieChart data={rows} vx={vx} vy={selectedVy} renderValue={renderValue} />}
            {type === 'bar' && <JourneyBarChart data={rows} vx={vx} vy={selectedVy} renderValue={renderValue} />}
            {type === 'hexagon' && <JourneyPoligonChart data={rows} vx={vx} vy={selectedVy} renderValue={renderValue} />}
        </>
    )
}

export default DashView